import { createFileRoute } from "@tanstack/react-router";
import CultivationCheck from "../../app/views/cultivation/cultivationCheck";

const FeedCheck = () => <CultivationCheck cultivationType="foder" />;

export const Route = createFileRoute("/feed/check")({
  component: FeedCheck,
});
